import useLazyBaseFetch from "../../internal/fetch/useLazyBaseFetch";
/**
 * @see https://sail.stripe.me/data/api/useLazyJsonFetch
 */ export default function useLazyJsonFetch(/** The URL of the resource to be fetched. */ url, /** An object containing custom settings to be applied to the request. */ options = {}) {
    return useLazyBaseFetch(url, options, 'json');
}

//# sourceMappingURL=useLazyJsonFetch.js.map